import { DecoratedKitRequestLine } from 'hooks/useGetDecoratedKitRequestLines';
import { EstimatedHandlingRequestData } from 'hooks/useGetDecoratedKitRequestLines/utils';
import { KitRequestSchemaLite } from 'types/kitting';

// Time in minutes for each operation
export const PROCESSING_TIMES = {
  REEL: 1, // 1 minutes per reel
  SHIPMENT_LINE: 1.5, // 1.5 minutes per line
  MERGE: 2, // 2 minutes per merge
  SPLIT: 2, // 2 minutes per split
} as const;

// Minimum number of business days for processing
export const MINIMUM_PROCESSING_DAYS = 2;

/**
 * Props for estimating kit ship date calculations
 * @property {DecoratedKitRequestLine[]} [decoratedKitRequestLines] - Array of kit request lines with their allocations
 * @property {EstimatedHandlingRequestData} [handlingRequestData] - Pre-calculated handling request data
 * @property {KitRequestSubtype} [kitRequest] - The kit request
 */
export type EstimateKitShipDateProps = {
  decoratedKitRequestLines?: DecoratedKitRequestLine[];
  handlingRequestData: EstimatedHandlingRequestData;
  kitRequest: Pick<
    KitRequestSchemaLite,
    | 'approved'
    | 'estimatedShipDate'
    | 'targetShipDate'
    | 'shipPartial'
    | 'approvedAt'
  > | null;
};

/**
 * Result type for the estimated ship date calculation
 * @property {string | null} estimatedShipDate - The calculated ship date in universal format, or null if cannot be calculated
 * @property {Object | null} latestExpectedStockLot - Information about the latest expected stock lot
 */
export type EstimatedShipDateResult = {
  estimatedShipDate: string | null;
  estimatedProcessingDate: string | null;
  latestExpectedStockLot:
    | {
        stockLot: DecoratedKitRequestLine['allocations'][0]['stockLot'];
        expectedBy: string | null;
      }
    | null
    | undefined;
  estimatedShipDateToRender: string | null;
  hasEstimatedShipDateChanged: boolean;
};
